import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkySectionedFormComponent } from './sectioned-form.component';
import { SkySectionedFormSectionComponent } from './sectioned-form-section.component';
import { SkyVerticalTabsetModule } from '../vertical-tabset/vertical-tabset.module';


export class SkySectionedFormModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkySectionedFormComponent,
    SkySectionedFormSectionComponent
  ],
  imports: [
    CommonModule,
    SkyVerticalTabsetModule
  ],
  exports: [
    SkySectionedFormComponent,
    SkySectionedFormSectionComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
